import React from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { TODIS_PRIMARY_SUBMIT_BTN } from "../../components/Buttons";
import arrow from "../../assets/icons/arrow-white.svg";
import { useState } from "react";
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2'
import EmailService from "../../HttpService/EmailService";

const TODIS_RESET_PASSWORD_FORM = () => {
    const [email, setEmail] = useState("");
    const [formSubmitted, setFormSubmitted] = useState(false);

    const hadleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleSubmit = event => {
        event.preventDefault();
        setFormSubmitted(true);
        if(email!=''){
            sendEmail(email);
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'The email has been sent, please wait to be redirected!',
                showConfirmButton: false,
                timer: 1500
            });}
    };

    const sendEmail = async (email) => {
        try {
            await new EmailService().sendEmail(email);
            window.location.href = `/TODIS-APP/`;
            //console.log('Email sent successfully');
        } catch (error) {
            console.error('Error sending email:', error);
        }
    };

    return (
        <Container fluid className="todis-form-wrapper">
            <Col className="p-4">
                <Link to="/TODIS-APP">
                    <button className="text-center todis-header mb-2">Back to Sign In</button>
                </Link>
            </Col>
            <h2 className="text-center todis-header mb-5">Enter your registered email address to reset your password</h2>

            <Form className="mt-5" onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Control type="text" placeholder="EMAIL" style={{ ...text_styles, border: '2px solid #004494', width: '66.66%', margin: '0 auto'  }} className="todis-forms" onChange={hadleEmailChange} value={email} />
                </Form.Group>
                {formSubmitted && email === '' ? (
                    <div>
                        <h5 style={{ color: "red", textAlign: "center" }}>Email cannot be empty</h5>
                    </div>
                ) : null}

                <Row className="d-flex justify-content-center">
                    <Col xs={6} md={6} lg={6} xl={6} xxl={6} className="p-2"><TODIS_PRIMARY_SUBMIT_BTN title="Reset Password" image={arrow} type="submit" /></Col>
                </Row>
            </Form>
        </Container>
    )
}

export default TODIS_RESET_PASSWORD_FORM;

const text_styles = {
    borderRadius: '19px',
    padding: '1rem',
    marginTop: '2rem',
    border: '0px',
    color: '#0B4CA1'
}